"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = void 0;

var Range_1 = require("./Range");

var NumberUtils_1 = require("./NumberUtils");

var Circle =
/*#__PURE__*/
function (_Range_1$Range) {
  _inherits(Circle, _Range_1$Range);

  function Circle(x, y, radius) {
    var _this;

    _classCallCheck(this, Circle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Circle).call(this, x, y));
    _this.radius = radius;
    return _this;
  }

  _createClass(Circle, [{
    key: "contains",
    value: function contains(point) {
      return (0, NumberUtils_1.getDistance)(point, this.position) <= this.radius;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      var rect = range;
      var circle = range;
      var pos1 = this.position;
      var pos2 = range.position;
      var xDist = Math.abs(pos2.x - pos1.x);
      var yDist = Math.abs(pos2.y - pos1.y);
      var r = this.radius;

      if (circle.radius !== undefined) {
        var rSum = r + circle.radius;
        var dist = Math.sqrt(xDist * xDist + yDist + yDist);
        return rSum > dist;
      } else if (rect.size !== undefined) {
        var w = rect.size.width;
        var h = rect.size.height;
        var edges = Math.pow(xDist - w, 2) + Math.pow(yDist - h, 2);

        if (xDist > r + w || yDist > r + h) {
          return false;
        }

        if (xDist <= w || yDist <= h) {
          return true;
        }

        return edges <= r * r;
      }

      return false;
    }
  }]);

  return Circle;
}(Range_1.Range);

exports.Circle = Circle;